var _polygon;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavAr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 116",
    enableBackground: "new 0 0 512 116",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "AR_00000170254863579910308120000005575687771121968304_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 58,
    x2: 512,
    y2: 58
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F34497"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#8938FC"
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "AR",
    fill: "url(#AR_00000170254863579910308120000005575687771121968304_)",
    points: "478.8,0 455.2,27.8 382.8,27.8  364.1,51.1 331.8,51.1 316.6,75.1 284.8,75.1 266.1,99.9 113.5,99.9 94.3,74.4 59.7,74.4 45,51.1 0,51.1 0,116 512,116 512,0 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavAr);
export default __webpack_public_path__ + "static/media/Nav-AR.65163f70.svg";
export { ForwardRef as ReactComponent };